import React from 'react';
import './css/footer.css'
import logo from './media/logo.png';
import style from "./css/footerNav.module.css";
import bg3 from './media/bg3.svg'
interface FooterProps {

}

const Footer: React.FC<FooterProps> = () => {

    return (
        <>
            <footer>
                <nav className={style.nav}>

                    <div className={style.brand}>
                        <img src={logo} alt="" className={style.logo} />
                    </div>


                    <ul className={style.navList}>
                        <a href="/about/"><li className={style.listItem}>About Us</li></a>
                        <a href="/support/"><li className={style.listItem}>Contact Us</li></a>
                        <a href="/"><li className={style.listItem}>Terms & Condition</li></a>
                        <a href="/"><li className={style.listItem}>Privacy Policy</li></a>
                    </ul>
                </nav>

                <div className="pseudo-nav" style={{ height: "100px", width: "100vw" }}></div>

                <div className={style.footerItem}>
                    <div className={style.item0}>
                        <img src={logo} alt="" />
                        <p className={style.logoName}>
                            MICHIS PICKS
                        </p>
                    </div>
                    <div className={style.item1}>
                        <p className={style.t1}>
                            Your security and privacy are our top priorities. With state-of-the-art encryption and strict data protection policies, you can bet with confidence, knowing your information is safe and secure.
                        </p>

                        <div className={style.socials}>
                            {/* <a href="">
                                <div className={style.s}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="31" viewBox="0 0 18 31" fill="none">
                                        <path d="M16.5833 1H12.3333C10.4547 1 8.65304 1.74628 7.32466 3.07466C5.99628 4.40304 5.25 6.20472 5.25 8.08333V12.3333H1V18H5.25V29.3333H10.9167V18H15.1667L16.5833 12.3333H10.9167V8.08333C10.9167 7.70761 11.0659 7.34728 11.3316 7.0816C11.5973 6.81592 11.9576 6.66667 12.3333 6.66667H16.5833V1Z" fill="#13A31F" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </a> */}
                            <a href="https://www.instagram.com/michispickspro" target='_blank'>
                                <div className={style.s}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path d="M1 12.5556C1 7.10856 1 4.38433 2.69289 2.69289C4.38578 1.00144 7.10856 1 12.5556 1H15.4444C20.8914 1 23.6157 1 25.3071 2.69289C26.9986 4.38578 27 7.10856 27 12.5556V15.4444C27 20.8914 27 23.6157 25.3071 25.3071C23.6142 26.9986 20.8914 27 15.4444 27H12.5556C7.10856 27 4.38433 27 2.69289 25.3071C1.00144 23.6142 1 20.8914 1 15.4444V12.5556Z" stroke="white" stroke-width="2" />
                                        <path d="M21.6673 7.4987C21.6673 8.14303 21.145 8.66536 20.5007 8.66536C19.8563 8.66536 19.334 8.14303 19.334 7.4987C19.334 6.85437 19.8563 6.33203 20.5007 6.33203C21.145 6.33203 21.6673 6.85437 21.6673 7.4987Z" stroke="white" stroke-width="2" />
                                        <path d="M14.0009 19.0564C16.793 19.0564 19.0564 16.793 19.0564 14.0009C19.0564 11.2088 16.793 8.94531 14.0009 8.94531C11.2088 8.94531 8.94531 11.2088 8.94531 14.0009C8.94531 16.793 11.2088 19.0564 14.0009 19.0564Z" stroke="white" stroke-width="2" />
                                    </svg>
                                </div>
                            </a>
                            <a href="https://t.me/michispicks"  target='_blank'>
                                <div className={style.s}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24" fill="none">
                                        <path d="M13.5659 16.1697L17.6459 20.676C19.1561 22.3448 19.9125 23.1798 20.7041 22.9757C21.4944 22.7727 21.7663 21.6749 22.3087 19.4779L25.3165 7.29158C26.1534 3.90757 26.5713 2.21678 25.6425 1.38178C24.7137 0.546781 23.1041 1.16784 19.8848 2.40872L4.95138 8.17059C2.37648 9.16452 1.08903 9.66088 1.00723 10.5142C0.997592 10.6012 0.997592 10.6889 1.00723 10.7758C1.08651 11.6304 2.37145 12.1304 4.94383 13.1317C6.10795 13.5853 6.69064 13.8127 7.10846 14.2467C7.15545 14.2956 7.20075 14.3461 7.24438 14.3983C7.62948 14.8628 7.79309 15.4741 8.12156 16.6918L8.73697 18.9743C9.05537 20.1601 9.2152 20.7543 9.63428 20.835C10.0534 20.9157 10.4171 20.4242 11.1457 19.44L13.5659 16.1697ZM13.5659 16.1697L13.1669 15.7663C12.7113 15.3042 12.4835 15.0743 12.4835 14.7882C12.4835 14.5022 12.7101 14.2711 13.1669 13.8102L17.6635 9.25744" fill="#13A31F" />
                                        <path d="M13.5659 16.1697L17.6459 20.676C19.1561 22.3448 19.9125 23.1798 20.7041 22.9757C21.4944 22.7727 21.7663 21.6749 22.3087 19.4779L25.3165 7.29158C26.1534 3.90757 26.5713 2.21678 25.6425 1.38178C24.7137 0.546781 23.1041 1.16784 19.8848 2.40872L4.95138 8.17059C2.37648 9.16452 1.08903 9.66088 1.00723 10.5142C0.997592 10.6012 0.997592 10.6889 1.00723 10.7758C1.08651 11.6304 2.37145 12.1304 4.94383 13.1317C6.10795 13.5853 6.69064 13.8127 7.10846 14.2467C7.15545 14.2956 7.20075 14.3461 7.24438 14.3983C7.62948 14.8628 7.79309 15.4741 8.12156 16.6918L8.73697 18.9743C9.05537 20.1601 9.2152 20.7543 9.63428 20.835C10.0534 20.9157 10.4171 20.4242 11.1457 19.44L13.5659 16.1697ZM13.5659 16.1697L13.1669 15.7663C12.7113 15.3042 12.4835 15.0743 12.4835 14.7882C12.4835 14.5022 12.7101 14.2711 13.1669 13.8102L17.6635 9.25744" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </a>

                        </div>
                    </div>
                    <div className={style.item2}>
                        <img src={bg3} alt="" />
                    </div>

                </div>

            </footer>
        </>
    );
};

export default Footer;